var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRename(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14889_128044)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 0.625C4.65482 0.625 4.375 0.873733 4.375 1.18056C4.375 1.48738 4.65482 1.73611 5 1.73611H6.25V12.8472H5C4.65482 12.8472 4.375 13.096 4.375 13.4028C4.375 13.7096 4.65482 13.9583 5 13.9583H8.75C9.09517 13.9583 9.375 13.7096 9.375 13.4028C9.375 13.096 9.09517 12.8472 8.75 12.8472H7.5V1.73611H8.75C9.09517 1.73611 9.375 1.48738 9.375 1.18056C9.375 0.873733 9.09517 0.625 8.75 0.625H5Z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.43121 2.29102H5.20898V3.54144H2.43121C1.81755 3.54144 1.3201 4.10126 1.3201 4.79186V9.79012C1.3201 10.4807 1.81756 11.0406 2.43121 11.0406H5.20898V12.291H2.43121C1.20391 12.291 0.208984 11.1713 0.208984 9.79012V4.79186C0.208984 3.41068 1.20391 2.29102 2.43121 2.29102ZM11.3201 11.0406H8.54232V12.291H11.3201C12.5474 12.291 13.5423 11.1713 13.5423 9.79013V4.79186C13.5423 3.41068 12.5474 2.29102 11.3201 2.29102H8.54232V3.54144H11.3201C11.9338 3.54144 12.4312 4.10128 12.4312 4.79186V9.79013C12.4312 10.4808 11.9338 11.0406 11.3201 11.0406Z",
    fill: "#212121"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14889_128044"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRename);
export default __webpack_public_path__ + "static/media/rename.f065c81201aa4b57c4e9a897e42a7063.svg";
export { ForwardRef as ReactComponent };